module.exports = __webpack_public_path__ + "static/media/group@2x.8c81a9be.png";